module.exports = __webpack_public_path__ + "static/media/15.9744f0aa.png";